export enum UserDataType {
	PersonalData = 'personalData',
	InvoiceData = 'invoiceData',
}
